const rankings = [
  {
    rank: 1,
    title: '长安十二时辰 第二季',
    type: '电视剧',
    hot: '本周播放量 1280 万',
    desc: '古装悬疑巨制回归，剧情再度升级，口碑与热度双丰收。',
  },
  {
    rank: 2,
    title: '星际救援：新纪元',
    type: '电影',
    hot: '本周播放量 1090 万',
    desc: '国产科幻新标杆，视觉效果震撼，剧情紧凑扣人心弦。',
  },
  {
    rank: 3,
    title: '人间烟火气',
    type: '综艺',
    hot: '本周播放量 965 万',
    desc: '慢综艺黑马，真实治愈的美食与人文之旅，好评如潮。',
  },
  {
    rank: 4,
    title: '深渊之下',
    type: '电影',
    hot: '本周播放量 872 万',
    desc: '悬疑犯罪题材力作，反转不断，结局令人意想不到。',
  },
  {
    rank: 5,
    title: '风云再起之龙虎斗',
    type: '电视剧',
    hot: '本周播放量 758 万',
    desc: '经典港剧风格回归，动作场面精彩，情怀与品质兼备。',
  },
  {
    rank: 6,
    title: '极地求生实录',
    type: '纪录片',
    hot: '本周播放量 634 万',
    desc: 'BBC 级别制作水准，绝美极地风光与野生动物故事。',
  },
  {
    rank: 7,
    title: '少年江湖行',
    type: '动漫',
    hot: '本周播放量 589 万',
    desc: '国漫口碑新作，画风精美，武侠世界观引人入胜。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时热度排行，发现大家都在看的好片好剧
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 bg-background-100 rounded-lg p-4 md:p-5 group cursor-pointer hover:bg-background-200 transition-colors"
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm shrink-0 ${
                idx < 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs font-medium text-accent-500 bg-accent-100/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>

              <div className="text-right shrink-0">
                <div className="text-xs font-medium text-accent-500 whitespace-nowrap">
                  <i className="ri-fire-line mr-1"></i>
                  {item.hot}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}